import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';

import commonStyles from 'styles/common.pcss';
import { ContentWrap, Grid, Col, FollowContainer } from 'bricks';
import { isScreenBelow1004 } from 'store/common/settings/breakpoint/selectors';
import {
  DETAILS_VIEW_SIMPLE,
  DETAILS_VIEW_TARIFF,
  DETAILS_VIEW_PREORDER,
} from 'store/ProductDetails/constants';
import { getDetailsViewSlug } from 'store/ProductDetails/selectors';
import { getPreorderOnlyBasket } from 'store/ProductDetails/preorder/selectors';

/* import FloatCard from './components/FloatCard'; */
import styles from './styles.pcss';

const cx = classNames.bind({ ...commonStyles, ...styles });

/**
 * Common wrapper for all the ProductDetails page tab contents,
 * used to build layout and inject common widgets
 */
class TabRouterLayout extends React.Component {
  state = { containerNode: null };

  // eslint-disable-next-line react/no-find-dom-node
  setRef = (ref) => this.setState({ containerNode: ReactDOM.findDOMNode(ref) });

  getContainerDOMNode = () => this.state.containerNode;

  render() {
    const { children, sidebar, RightCol, viewSlug, className, isMobile, onlyBasket } = this.props;

    const showFloatingCard = () => {
      if (viewSlug === DETAILS_VIEW_PREORDER && onlyBasket) {
        return true;
      }
      return viewSlug === DETAILS_VIEW_SIMPLE || viewSlug === DETAILS_VIEW_TARIFF;
    };
    return (
      <div className={cx('component', className)}>
        <ContentWrap size={['xl']}>
          <Grid>
            <Col size={8} l={12} className={cx('body')}>
              {children}
            </Col>
            {sidebar || !isMobile ?
              <Col size={4} l={12} className={cx(!isMobile ? 'side' : null)}>
                {sidebar}
                <div ref={this.setRef} className={cx('relative', 'fullHeight')}>
                  {((!isMobile && showFloatingCard()) || RightCol) && (
                    <FollowContainer
                      watchResize
                      offsetTop={140}
                      toggleAnimation="fade"
                      containerNode={this.getContainerDOMNode()}
                    >
                      {RightCol && <RightCol />}
                      {/* <FloatCard /> */}
                    </FollowContainer>
                  )}
                </div>
              </Col>
            : null}
          </Grid>
        </ContentWrap>
      </div>
    );
  }
}

TabRouterLayout.propTypes = {
  children: PropTypes.node,
  sidebar: PropTypes.node,
  viewSlug: PropTypes.string,
  className: PropTypes.string,
  isMobile: PropTypes.bool,
  onlyBasket: PropTypes.bool,
  RightCol: PropTypes.node,
};

const mapStateToProps = (state) => ({
  viewSlug: getDetailsViewSlug(state),
  isMobile: isScreenBelow1004(state),
  onlyBasket: getPreorderOnlyBasket(state),
});

export default connect(mapStateToProps)(TabRouterLayout);
